module.exports = __webpack_public_path__ + "media/images/default/homepage/environment/group_33676_orange-60b9726cc9a7072b965ccc11a5f3baa3.svg";